<template>
  <div>
    <!-- Error Display -->
    <section v-if="errorMessage" class="rounded-2xl border border-[#b42318]/30 bg-[#b42318]/5 p-4">
      <div class="flex items-center gap-2">
        <svg
          class="w-5 h-5 text-[#b42318] flex-shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <p class="text-sm text-[#b42318]">
          {{ errorMessage }}
        </p>
      </div>
    </section>

    <!-- Wallet Assist -->
    <section
      v-if="walletAssistVisible"
      class="rounded-2xl border border-[#1980e6]/20 bg-[#1980e6]/5 p-4 space-y-3"
      :class="errorMessage ? 'mt-4' : ''"
    >
      <p class="text-sm text-[#0e141b]">
        {{ walletAssistMessage }}
      </p>
      <button
        v-if="hasResumeUrl"
        type="button"
        class="w-full rounded-xl border border-[#1980e6]/30 bg-white px-4 py-2.5 text-sm font-medium text-[#1980e6] hover:bg-[#1980e6]/5 transition-colors"
        @click="$emit('open-wallet-assist')"
      >
        Open {{ walletAssistName }}
      </button>
      <p v-else class="text-xs text-[#4e7397]">
        Return to {{ walletAssistName }} and approve or reject the pending request there.
      </p>
    </section>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  errorMessage: string
  walletAssistVisible: boolean
  walletAssistMessage: string
  walletAssistName: string
  hasResumeUrl: boolean
}>()

defineEmits<(e: 'open-wallet-assist') => void>()
</script>
